import { render, staticRenderFns } from "./PPCharacter.vue?vue&type=template&id=62be7336"
import script from "./PPCharacter.vue?vue&type=script&lang=js"
export * from "./PPCharacter.vue?vue&type=script&lang=js"
import style0 from "./PPCharacter.vue?vue&type=style&index=0&id=62be7336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports